function moveSizeGuideDrawersToBody() {
  document.querySelectorAll('.size-guide-drawer').forEach((drawer) => {
    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }
  });
}

function openSizeGuideDrawer(button, event) {
  moveSizeGuideDrawersToBody();

  const drawerId = button.getAttribute('data-size-guide-open');
  const drawer = document.getElementById(drawerId);

  if (!drawer) return;

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';
}

['pointerdown', 'mousedown', 'touchstart', 'click'].forEach((eventName) => {
  document.addEventListener(
    eventName,
    (event) => {
      const openButton = event.target.closest('[data-size-guide-open]');

      if (!openButton) return;

      if (eventName === 'click') {
        openSizeGuideDrawer(openButton, event);
      } else {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
    },
    true
  );
});

document.addEventListener(
  'click',
  (event) => {
    const closeButton = event.target.closest('[data-size-guide-close]');

    if (!closeButton) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const drawer = closeButton.closest('.size-guide-drawer');

    if (!drawer) return;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  },
  true
);

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  document.querySelectorAll('.size-guide-drawer.is-open').forEach((drawer) => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  });
});

document.addEventListener('DOMContentLoaded', moveSizeGuideDrawersToBody);